import {
  Box,
  Button,
  Flex,
  Table,
  TableContainer,
  Tbody,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
} from "@chakra-ui/react";
import TableLoader from "components/common/TableLoader/TableLoader";
import { FieldArray } from "formik";
import { FaPlus } from "react-icons/fa";
import UserApproval from "./UserApproval";
import { isActiveUser, levels, roles } from "../utils/constant";
import CustomInput from "components/common/customInput/CustomInput";

const ApprovalsForm = ({
  activePage,
  values,
  setFieldValue,
  isDisabled,
  setDeletedApproavals,
  type,
  loadOptions,
  data,
  showError,
  generateLevels,
  isLoading,
  debouncedLoadOptions,
}: any) => {

  console.log(values.approvals)
  return (
    <Box display={activePage === 1 ? undefined : "none"}>
      <Flex justifyContent="space-between">
        <Flex alignItems="center" gap={3}>
          <Text mt={2} fontWeight="500" whiteSpace="nowrap">
            Differentiate First Level Users:
          </Text>
          <CustomInput
            disabled={isDisabled}
            type="switch"
            value={values.differentiateFirstLevel}
            name="differentiateFirstLevel"
            onChange={(e: any) =>
              setFieldValue(`differentiateFirstLevel`, e.target.checked)
            }
          />
        </Flex>
        {values.approvals?.length === 0 && (
          <Tooltip label="Add Approval" placement="left" hasArrow>
            <Button
              onClick={() => {
                setFieldValue("approvals", [
                  ...values.approvals,
                  {
                    username: "",
                    role: roles[1],
                    level: levels[0],
                    password: "abc123",
                    addNew: 1,
                    designation: "",
                    canUpload: isActiveUser[1],
                    isActive: isActiveUser[0],
                    selectMode: "select-async",
                  },
                ]);
              }}
              bg="teal.400"
              color="white"
              _hover={{ bg: "teal.500" }}
              disabled={isDisabled}
            >
              <FaPlus />
            </Button>
          </Tooltip>
        )}
      </Flex>
      <Box mt={4}>
        <Box
          position="relative"
          // width={{ lg: "calc(100vw - 13.8rem)" }}
          overflow="auto"
          className="customScrollBar"
        >
          <TableContainer overflow="auto"
            className="customScrollBar">
            <Table variant={"striped"}>
              <Thead>
                <Tr>
                  <Th whiteSpace="nowrap">User Name</Th>
                  <Th>Role</Th>
                  <Th>Level</Th>
                  <Th whiteSpace="nowrap">Keep Active</Th>
                  <Th>Designation</Th>
                  <Th textAlign={'center'}>Permissions</Th>
                  {/* <Th display="none">Password</Th> */}
                  <Th></Th>
                </Tr>
              </Thead>
              <FieldArray name="approvals">
                {({ remove }) => (
                  <TableLoader
                    loader={false}
                    show={values.approvals.length}
                    noDataText="Create a New Initial User"
                  >
                    <Tbody>
                      {Array.from(
                        { length: values.approvals.length },
                        (_, index) => (
                          <UserApproval
                            key={index}
                            index={index}
                            values={values}
                            setFieldValue={setFieldValue}
                            loadOptions={loadOptions}
                            remove={remove}
                            type={type}
                            isDisabled={isDisabled}
                            setDeletedApproavals={setDeletedApproavals}
                            data={data}
                            isLoading={isLoading}
                            generateLevels={generateLevels}
                            debouncedLoadOptions={debouncedLoadOptions}
                          />
                        )
                      )}
                    </Tbody>
                  </TableLoader>
                )}
              </FieldArray>
            </Table>
          </TableContainer>

          {values.approvals.length > 0 && (
            <Flex justify="center" mt={4}>
              <Button
                leftIcon={<FaPlus />}
                size="sm"
                colorScheme="teal"
                onClick={() =>
                  setFieldValue("approvals", [
                    ...values.approvals,
                    {
                      username: "",
                      role: {label : "Approver", value : 'approver'},
                      level: {label : 'Level-1', value : 'level-1'},
                      isActive: {label : 'Yes', value : true},
                      designation: "",
                      addNew: 1,
                      canUpload: false,
                      canSendMail: false,
                    },
                  ])
                }
                isDisabled={isDisabled}
              >
                Add User
              </Button>
            </Flex>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default ApprovalsForm;
